
import React from 'react';
import { Typography, Tag } from 'antd';
import { AnalysisResult, AnalysisStatus } from '../../../types';

const { Text } = Typography;

interface RepairAnalysisProps {
  results: AnalysisResult;
  status: AnalysisStatus;
}

const RepairAnalysis: React.FC<RepairAnalysisProps> = ({ results, status }) => {
  const { suggested_repairs } = results;

  if (status === 'error') {
    return <Text>There was an unexpected error with repair analysis, once the report is complete, please rerun the analysis.</Text>;
  } else if (status === 'skipped') {
    return <Text>Repair analysis was skipped by the user.</Text>;
  }

  if (!suggested_repairs) {
    return <Text>No repair analysis data available.</Text>;
  }

  return (
    <div>

      {suggested_repairs['repair summary'] && suggested_repairs['repair summary']['Overall cost estimate'] && (
        <div style={{
          marginBottom: '20px',
          padding: '16px'
        }}>
          <Text strong style={{ fontSize: '16px' }}>
            💰 Overall Repair Cost Estimate: {suggested_repairs['repair summary']['Overall cost estimate']}
          </Text>
        </div>
      )}
      {suggested_repairs['suggested repairs'] && suggested_repairs['suggested repairs'].length > 0 ? (
        <div>
          {suggested_repairs['suggested repairs']
            .sort((a: any, b: any) => a.Priority - b.Priority)
            .map((repair: any, index: number) => (
              <div key={index} style={{
                marginBottom: '16px',
                padding: '16px',
                border: '1px solid #f0f0f0',
                borderRadius: '6px',
                backgroundColor: '#fafafa'
              }}>
                <div style={{ marginBottom: '12px' }}>
                  <Tag color={repair.Priority === 1 ? 'red' : repair.Priority === 2 ? 'orange' : 'blue'} style={{ marginBottom: '8px' }}>
                    Priority {repair.Priority}
                  </Tag>
                  <Text strong style={{ fontSize: '16px', marginLeft: '8px' }}>
                    {repair.Area}
                  </Text>
                </div>

                <div style={{ lineHeight: '1.6' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <Text strong>Detected Issue:</Text> {repair['Detected Issue']}
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <Text strong>Repair Suggestion:</Text> {repair['Repair Suggestion']}
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <Text strong>Repair Cost Estimate:</Text>
                    <Text type="secondary" style={{ marginLeft: '4px' }}>
                      {repair['Repair Cost Estimate']}
                    </Text>
                  </div>
                  <div>
                    <Text strong>Source:</Text>
                    <Tag color="geekblue" style={{ marginLeft: '4px' }}>
                      {repair.Source.replace(/&amp;/g, '&')}
                    </Tag>
                  </div>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <Text type="secondary">Something went wrong. Please try again.</Text>
      )}
    </div>
  );
};

export default RepairAnalysis;
